module.exports = __webpack_public_path__ + "img/category-skill-game-hover.d89ee2e1.png";